var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-surnames-results-empty results-empty"},[_c('h5',[_vm._v("No match found for \""+_vm._s(_vm.searchText)+"\"")])])}
var staticRenderFns = []

export { render, staticRenderFns }